import React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import {Divider} from "@mui/material";
import StepLabel from "@mui/material/StepLabel";
import Button from "../buttons/Button";
import {ArrowLeftIcon, ArrowRightIcon} from "@mui/x-date-pickers";
import GF from "../../../../lib/utils/GF";
import CampaignService from "../../../model/service/campaign/CampaignService";
import {toast} from "react-toastify";
import {ScheduleSendOutlined} from "@mui/icons-material";
import LoadingButton from "@mui/lab/LoadingButton";
import BaseComponent from "../../../../lib/components/BaseComponent";
import PropTypes from "prop-types";
import WizardData from "./WizardData";
import CM from "../../../model/system/CM";
import HorizontalLayout from "../../../../lib/components/layouts/HorizontalLayout";
import InputText from "../inputFields/InputText";
import InputNumber from "../inputFields/InputNumber";
import VerticalLayout from "../../../../lib/components/layouts/VerticalLayout";
import ConfirmationDialog from "../../../../lib/components/dialogs/ConfirmationDialog";
import StepSelectList from "./steps/StepSelectList";
import StepConfiguration from "./steps/StepConfiguration";
import StepDateSelection from "./steps/StepDateSelection";
import StepOverview from "./steps/StepOverview";
import StepComments from "./steps/StepComments";
import FilterListDialog from "../filterManager/FilterListDialog";
import OmsModuleService from "../../../../lib/model/campaign/modules/omsModule/v001/service/OmsModuleService";
import SendOutput from "../../../../lib/model/campaign/modules/omsModule/v001/service/dto/SendOutput";
import EntityDescribe from "../../../../lib/model/service/entity/dto/EntityDescribe";
import Operator from "../../../../lib/model/query/Operator";
import Query from "../../../../lib/model/query/Query";
import BooleanPredicate from "../../../../lib/model/query/BooleanPredicate";
import FieldPredicate from "../../../../lib/model/query/FieldPredicate";
import FieldName from "../../../../lib/model/query/FieldName";

const steps = ['Liste auswählen', 'Konfiguration', 'Versandtermin', 'Bemerkungen', 'Übersicht'];

class MailingStepper extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      isLoading: false,
      testMailDialog: null,
      requestIsActive: false,
      isFilterListDialogOpen: false,
      filterListRows: [],
      filterListData: [],
      selectedFilterRow: null,
      nextStepButtonDisabled: false
    };
    this.data = new WizardData();

    let config = this.data.getConfiguration();
    config.setSendFromText(this.props.configurations.mailToDisplayName.join(','));
    config.setSendFromAddressOptions(this.props.configurations.mailToAddresses);
    config.setSendFromAddress(config.getSendFromAddressOptions()[0]);
    config.setTemplates(this.props.configurations.templates);
    config.setTemplate(config.getTemplates()[0]);
    this.data.setConfiguration(config);
    this.data.setMailGenerateRoute(this.props.mailGenerateRoute);
  }

  componentDidMount() {
    super.componentDidMount();

    this.doLoadFilterListDialog(() => {
      this.setState({isFilterListDialogOpen: true});
    });
  }

  sendMailing(wizardData, campaignId, testMailReceiver = '', numOfTestMails = 0) {
    if (!this.state.requestIsActive) {
      this.setState({isLoading: true, requestIsActive: true});
      let config = wizardData.getConfiguration();

      this.getQuery(wizardData.getQuery(), (query) => {
        let notiz = wizardData.getNotiz();
        if (notiz === '') {
          notiz = 'keine Angaben';
        }
        let submitOutput = OmsModuleService.buildSubmitOutputDto('campaign_' + campaignId, notiz,
          config.getTemplate(), GF.dateTimeToString(wizardData.getDeliveryDateTime()), config.getSendFromAddress(),
          config.getSendFromText(), testMailReceiver, numOfTestMails, query,
          wizardData.getMailGenerateRoute());
        submitOutput.setProperties(CampaignService.createCampaignIdProperty(campaignId));

        CM.get().doJsonAjax(CM.get().getServiceUrl(OmsModuleService.NAME), submitOutput, (response) => {
          this.setState({isLoading: false, requestIsActive: false});
          if (response.success) {
            let sendOutput = new SendOutput();
            CM.get().doJsonAjax(CM.get().getServiceUrl(OmsModuleService.NAME), sendOutput, (response) => {
              this.setState({isLoading: false, requestIsActive: false});
              if (response.success) {
                toast.success('Die Versandaufgabe war erfolgreich.');
                if (testMailReceiver) {
                  this.setState({testMailDialog: null});
                } else {
                  CM.get().closeMainDialog();
                }
              } else {
                toast.error(response.message);
              }
            });
          } else {
            toast.error(response.message);
          }
        });
      });
    }
  }

  getQuery = (query, callback) => {
    if (!query) {
      let describeTable = new EntityDescribe([this.props.entityName]);
      describeTable.setProperties(CampaignService.createCampaignRedirectProperty(this.props.campaignId));

      this.doDataFetch(describeTable, 'DoctrineEntityService', (response) => {
        if (response.success) {
          let entityDef = response.data.serviceDescription.entityDefs[0];
          query = this.buildSelectAllRowsQuery(entityDef);
          callback(query);
        } else {
          if (response.message !== undefined) {
            toast.error(response.message);
          } else {
            toast.error('Die Abfrage konnte nicht generiert werden!');
          }
          callback(null);
        }
      });
    } else {
      callback(query);
    }
  }

  buildSelectAllRowsQuery = (entityDef) => {
    let booleanPredicate = new BooleanPredicate(Operator.and);
    let fieldName = new FieldName(entityDef.fieldsDef.id.name, entityDef.baseDef.name);
    booleanPredicate.addPredicate(new FieldPredicate(fieldName, '', '', '', Operator.neq));

    return new Query([fieldName.getFullFieldName()], null, '', [], [], 0, 999999999999);
  }

  totalSteps = () => {
    return steps.length;
  };

  isLastStep = () => {
    return this.state.activeStep === this.totalSteps() - 1;
  };

  handleNext = () => {
    if (!this.isLastStep()) {
      this.setState((prevState) => ({
        activeStep: prevState.activeStep + 1,
        nextStepButtonDisabled: prevState.activeStep + 1 === 4
      }));
    }
  };

  handleBack = () => {
    this.setState((prevState) => ({
      activeStep: prevState.activeStep - 1,
      nextStepButtonDisabled: prevState.activeStep - 1 === 4
    }));
  };

  handleSendTestMail = () => {
    let testMailForSending = CM.get().getUserContext().email;
    let numOfTestMails = 1;
    let testMailDialog = <ConfirmationDialog
      confirmButtonText='Testmail aufgeben'
      title='Testmail versenden'
      open={true}
      onConfirmClick={() => this.sendMailing(this.data, this.props.campaignId, testMailForSending, numOfTestMails)}
      onCancelClick={() => this.setState({testMailDialog: null})}>
      <VerticalLayout className='gap-4'>
        <InputText
            onChange={(e, id, value) => testMailForSending = value}
            helpTextElement='Testmails werden an folgender Adresse versendet'
            labelElement='E-Mailadresse' defaultValue={testMailForSending}/>
        <InputNumber
            regex='/^-?\d*(\.\d*)?$/'
            defaultValue={numOfTestMails} labelElement='Anzahl Testmails'
            onChange={(e, id, value) => numOfTestMails = value}
            helpTextElement='Wenn die Anzahl der Testmails die Anzahl der vorhandenen Kontakte überschreitet, werden die überzähligen Mails ignoriert!'/>
      </VerticalLayout>
    </ConfirmationDialog>;
    this.setState({testMailDialog});
  }

  handleSendMailing = () => {
    this.sendMailing(this.data, this.props.campaignId);
  }

  stepSelectListOnRowChanged = (dataRecord) => {
    this.setState({selectedFilterRow: dataRecord});
  }

  stepSelectListOnReadyChanged = (info) => {
    this.setState({nextStepButtonDisabled: info.nextStepButtonDisabled});
  }

  doLoadFilterListDialog = (callback) => {
    let sysLastValueId = FilterListDialog.buildSysLastValueId(this.props.campaignId, this.props.entityName);

    FilterListDialog.loadFilterList(sysLastValueId, (filterListRows, filterListData) => {
      if (callback) {
        this.setState({filterListRows: filterListRows, filterListData: filterListData});
        callback();
      }
    }, true);
  }

  render() {
    const {activeStep, nextStepButtonDisabled} = this.state;
    const {campaignId, entityName} = this.props;

    if (this.state.selectedFilterRow && this.state.selectedFilterRow.query) {
      this.data['query'] = this.state.selectedFilterRow.query;
    }
    this.data['campaignId'] = campaignId;

    const stepsContent = [<></>, <StepConfiguration configurations={this.data.getConfiguration()}/>,
      <StepDateSelection data={this.data}/>, <StepComments data={this.data}/>, <StepOverview data={this.data} onReadyChanged={this.stepSelectListOnReadyChanged} />];

    this.state.isFilterListDialogOpen = activeStep === 0;

    let stepperNextButtonLabel = '';
    if (this.isLastStep()) {
      stepperNextButtonLabel = 'Versand aufgeben';
    } else if (!this.state.selectedFilterRow && activeStep === 0) {
      stepperNextButtonLabel = 'Alle Kontakte versenden';
    } else {
      stepperNextButtonLabel = 'Weiter';
    }
    let stepperNextButtonLabelStyle = 'primary';
    if (stepperNextButtonLabel !== 'Weiter') {
      stepperNextButtonLabelStyle = 'error';
    }

    return (<Box className='flex flex-col gap-5'>
      <Stepper sx={{gap: 1}} nonLinear activeStep={activeStep}>
        {steps.map((label, index) => (<Step key={label} completed={index < activeStep}>
          <StepLabel>
            {label}
          </StepLabel>
        </Step>))}
      </Stepper>
      <Box>{<StepSelectList campaignId={campaignId} entityName={entityName} data={this.data} parent={this}
                            isFilterListDialogOpen={this.state.isFilterListDialogOpen}
                            filterListRows={this.state.filterListRows}
                            filterListData={this.state.filterListData}
                            onRowChanged={this.stepSelectListOnRowChanged}/>}{stepsContent[activeStep]}</Box>
      <Divider/>
      <Box>
        <Box className='flex justify-between gap-5'>
          <Button
            color=''
            startIcon={<ArrowLeftIcon/>}
            variant='outlined'
            onClick={this.handleBack}
            disabled={activeStep === 0}>
            Zurück
          </Button>
          <HorizontalLayout className='gap-4' widthFit>
            {activeStep === 1 && <Button
              onClick={this.handleSendTestMail}
              color='error'
              variant='outlined'>
              Testmail versenden
            </Button>}
            <LoadingButton
              variant='contained'
              loading={this.state.isLoading}
              endIcon={this.isLastStep() ? <ScheduleSendOutlined/> : <ArrowRightIcon/>}
              onClick={this.isLastStep() ? this.handleSendMailing : this.handleNext}
              color={stepperNextButtonLabelStyle}
              disabled={nextStepButtonDisabled}>
              {stepperNextButtonLabel}
            </LoadingButton>
          </HorizontalLayout>
        </Box>
      </Box>
      {this.state.testMailDialog}
    </Box>);
  }
}

MailingStepper.propTypes = {
  configurations: PropTypes.object,
  campaignId: PropTypes.number,
  entityName: PropTypes.string,
  mailGenerateRoute: PropTypes.string
}

export default MailingStepper;